import { appConfig } from '../config/app-config';

/**
 * Where an API path lives. One place, so nothing re-derives it and nothing writes a base URL at a
 * call site (005 FR-005).
 */
export function apiUrl(path: string): string {
  return `${appConfig().apiBaseUrl}${path}`;
}

/**
 * Whether a request is going to our API, compared by parsed origin rather than string prefix:
 * `'http://host:5176/x'.startsWith('http://host:5176')` is also true of
 * `http://host:5176@evil.example/x` and `http://host:51760/x`.
 */
export function isSameApi(requestUrl: string, apiBaseUrl: string): boolean {
  try {
    const target = new URL(requestUrl, document.baseURI);
    const api = new URL(apiBaseUrl, document.baseURI);
    return target.origin === api.origin;
  } catch {
    return false;
  }
}
